import React from 'react';

export const isAdmin = (permissions) => permissions && (permissions.includes('sport1_backend_admin') || permissions.includes('sport_admin_backend_admin'));
export const isView = (permissions) => permissions && permissions.includes('sport1_admin_backend_view');
export const isEditor = (permissions) => permissions && permissions.includes('sport_admin_backend_editor');
export const isMatchEditor = (permissions) => permissions && permissions.includes('sport_admin_backend_match');
